var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntertainmentSolid = function SvgEntertainmentSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.25A2.75 2.75 0 0 0 2.25 7v3c0 .414.336.75.75.75a1.25 1.25 0 0 1 0 2.5.75.75 0 0 0-.75.75v3A2.75 2.75 0 0 0 5 19.75h14A2.75 2.75 0 0 0 21.75 17v-3a.75.75 0 0 0-.75-.75 1.25 1.25 0 0 1 0-2.5.75.75 0 0 0 .75-.75V7A2.75 2.75 0 0 0 19 4.25H5Zm9.25 14h1.5V17a.75.75 0 0 0-1.5 0v1.25Zm1.5-12.5h-1.5V7a.75.75 0 0 0 1.5 0V5.75Zm-.75 4.5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgEntertainmentSolid;